"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RESET_DEADLINE_SECONDS = void 0;
exports.resetPopsDue = resetPopsDue;
exports.RESET_DEADLINE_SECONDS = 9;
/** Keep small resets leisurely; finish the pop sequence within six seconds. */
function resetPopsDue(count, elapsedSeconds) {
    if (count <= 0)
        return 0;
    const interval = Math.min(0.075, 6 / count);
    return Math.min(count, Math.floor(Math.max(0, elapsedSeconds) / interval));
}
//# sourceMappingURL=resetTiming.js.map